import { render, staticRenderFns } from "./page-detail.vue?vue&type=template&id=286d259a"
import script from "./page-detail.vue?vue&type=script&lang=js"
export * from "./page-detail.vue?vue&type=script&lang=js"
import style0 from "./page-detail.vue?vue&type=style&index=0&id=286d259a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports